import { Menu } from "antd";
import './index.css';
import { MdDashboardCustomize } from "react-icons/md";
import { MdLocalHospital } from "react-icons/md";
import { IoSchoolSharp } from "react-icons/io5";
import { MdShoppingCart } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function SideMenu() {
  const navigate = useNavigate();

  return (
    <div className="SideMenu">
      <Menu
        onClick={(item) => {
          navigate(item.key);
        }}
        items={[
          {
            label: "Dashboard",
            icon: <MdDashboardCustomize />,
            key: "/d",
          },
          {
            label: "Hospital",
            key: "/inventory",
            icon: <MdLocalHospital />,
          },
          {
            label: "School",
            key: "/orders",
            icon: <IoSchoolSharp />,
          },
          {
            label: "Shop",
            key: "/customers",
            icon: <MdShoppingCart />,
          },
        ]}
      />
    </div>
  );
}

export default SideMenu;
